import React, { useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Play } from "lucide-react";

export const isVideo = (p) => (p?.content_type || "").startsWith("video/") || /\.(mp4|mov|webm|3gp|m4v|avi)$/i.test(p?.filename || "");

export function PhotoThumb({ photo, size = "h-16 w-16" }) {
  const [open, setOpen] = useState(false);
  const src = `${api.defaults.baseURL}${photo.url.replace(/^\/api/, "")}`;
  const video = isVideo(photo);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={`${size} relative rounded border border-slate-200 overflow-hidden bg-slate-100 hover:ring-2 ring-[#2d7bd0]`} data-testid={`photo-thumb-${photo.id}`}>
        {video ? <><video src={`${src}#t=0.1`} muted preload="metadata" className="h-full w-full object-cover" /><span className="absolute inset-0 grid place-items-center bg-black/30"><Play className="h-5 w-5 text-white fill-white" /></span></>
          : <img src={src} alt={photo.filename || "attempt photo"} className="h-full w-full object-cover" loading="lazy" />}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl p-2" data-testid="photo-lightbox">
          {video ? <video src={src} controls autoPlay playsInline className="w-full max-h-[80vh] rounded bg-black" data-testid="video-player" />
            : <img src={src} alt={photo.filename || "attempt photo"} className="w-full max-h-[80vh] object-contain rounded" />}
          <div className="text-xs text-slate-500 px-2 pb-1 flex justify-between"><span>{photo.filename}</span><a href={src} download className="sm-link">Download</a></div>
        </DialogContent>
      </Dialog>
    </>
  );
}
